import { render, staticRenderFns } from "./Inscriptions.vue?vue&type=template&id=3d194cb7"
import script from "./Inscriptions.vue?vue&type=script&lang=js"
export * from "./Inscriptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports